// extracted by mini-css-extract-plugin
export var catcarous = "block_catscarou-module--catcarous--2e9b6";
export var catcarous_wr = "block_catscarou-module--catcarous_wr--e3c82";
export var cont = "block_catscarou-module--cont--e0f72";
export var cta = "block_catscarou-module--cta--4dfbe";
export var desk_noscroll = "block_catscarou-module--desk_noscroll--32bdd";
export var head = "block_catscarou-module--head--65f5e";
export var image = "block_catscarou-module--image--bff55";
export var link = "block_catscarou-module--link--87c31";
export var marrow = "block_catscarou-module--marrow--a6254";
export var nd_catcarou = "block_catscarou-module--nd_catcarou--b3d7e";
export var nd_ctaLink = "block_catscarou-module--nd_cta-link--6538d";
export var tile = "block_catscarou-module--tile--7dde2";
export var tiles = "block_catscarou-module--tiles--6e105";
export var title = "block_catscarou-module--title--9618d";
export var titleh = "block_catscarou-module--titleh--779d9";